import React from 'react'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import ActivitiesDetailsMain from '../Components/Activities/ActivitiesDetailsMain'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import SEO from '../Components/SEO/SEO'

function ActivitiesDetails() {
    return (
        <>
            <SEO 
                title="Activity Details - Tourm Travel Agency"
                description="Learn more about exciting activities and experiences available."
                url="/activities-details"
            />
            <HeaderOne />
            <Breadcrumb
                title="Activities Details"
            />
            <ActivitiesDetailsMain />
            <FooterFour />
            <ScrollToTop />
        </>
    )
}

export default ActivitiesDetails
